import { TutorBrowsePage } from "../../components/profile/TutorBrowsePage";
import { searchPublicTutor } from "../../store/profile/profileActions";

const PublicTutorList = () => {
    return <TutorBrowsePage searchThunk={searchPublicTutor} isPublic={true} />;
};

export { PublicTutorList };
